import FormApiController from './api/FormApiController';

class FormController {
  private readonly formId: string;
  private readonly formApiController: FormApiController;

  constructor(formId: string, baseClientUrl: string | undefined) {
    this.formId = formId;
    this.formApiController = new FormApiController(baseClientUrl);
  }

  private _formData: Map<string, unknown> = new Map<string, unknown>();

  get formData(): Map<string, unknown> {
    return this._formData;
  }

  getFormName(): string | undefined {
    return this._formData ? (this._formData.get('name') as string) : undefined;
  }

  initialize(): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    return new Promise<void>((resolve, reject) => {
      that.formApiController
        .loadFormData<Map<string, never> | null>(that.formId)
        .then((formData) => {
          if (formData) {
            that._formData = new Map(Object.entries(formData));
          }
          resolve();
        })
        .catch((error) => reject(error));
    });
  }
}

export default FormController;
